import { format } from 'date-fns'
/* eslint-disable */

const ACTION_FLAG = {
  1: 'CREATED',
  2: 'UPDATED',
  3: 'DELETED',
};
export const truncate = (value) => {
  if (value && typeof value === 'string' && value.length > 70) {
    return `${value.slice(0, 70)}....`;
  }
  return value;
};
export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const formatPermName =  (val) => {
  if (val)
    return val.toUpperCase().split('_').join(' ')
  return '';
}

export function cleanDate(value){
  return format(value, 'ddd, DD MMM YYYY')
}

export function djangoFlagType (value){
  return ACTION_FLAG[1];
}

export function isEmpty (value, ) {
  return value || "N/A";
}
export function nairaSign (value) {
  return `${String.fromCharCode(0x20A6) + value}`
}



// WEBPACK FOOTER //
// ./src/utils/filters.js